import { memo } from "react";
import ContentRenderWebpageComponent from "./ContentRenderWebpageComponent";
import "./Default.css";
import React from "react";
import { getRelationChildKey } from "./utilities/componentIdentity";

interface Props {
  childWebpageComponentRelations: any;
}

function RenderChildren({ childWebpageComponentRelations }: Props) {
  if (childWebpageComponentRelations && childWebpageComponentRelations.length) {
    return childWebpageComponentRelations.map(
      (webpageComponentRelation: any) => {
        const childKey = getRelationChildKey(webpageComponentRelation);
        if (!childKey) {
          return null;
        }
        const relationKey =
          webpageComponentRelation.id != null
            ? String(webpageComponentRelation.id)
            : webpageComponentRelation.sort ?? "";
        return (
          <ContentRenderWebpageComponent
            componentKey={childKey}
            key={`${childKey}_${relationKey}`}
          />
        );
      }
    );
  }
}

export default memo(RenderChildren);
